import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { maskDate } from "../utils/Masker";
import axios from 'axios';
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import TipoDocFrame from './TipoDocFrame';
import ModalPadraoForm from './ModalPadraoForm';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export default class ContratosForm extends Component {
  state = {
    registro: {
      contr_idf: 0,
      contr_pessoa: { key: '0', label: '' },
      contr_numero: '',
      contr_data_emissao: moment().format('DD/MM/YYYY'),
      contr_data_cancelamento: '',
      contr_situacao: '',
      contr_bloqueio: '',
      contr_valor_inicial: 0,
      contr_valor_mensal: 0,
      contr_dia_venc: 0,
      contr_obs: '',
      contr_controle: '',
      contr_vendedor: { key: '0', label: '' },
      contr_tipo_pagto: { key: '0', label: '', },
      contr_flag_fatura: false,
      contr_flag_emite_nfe: false,
      contr_flag_emite_boleto: false,
    },
    modalPagtosVisible: false,
    modalListaVisible: false,
    tipoTela: 'CONTR',
    contr_pessoa: { key: '0', label: '' },

    editando: false,
    visualizando: false,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.dados,
        visualizando: this.props.registroSelecionado.dados.visualizando,
        editando: this.props.registroSelecionado.dados.contr_idf ? true : false,
      }, () => {

      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }


  onOK = () => {

    if ((!this.state.registro.contr_data_emissao) || (!moment(this.state.registro.contr_data_emissao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.contr_pessoa) || (this.state.registro.contr_pessoa.key === '0') || (this.state.registro.contr_pessoa.key === 'null')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.registro.contr_tipo_pagto) || (this.state.registro.contr_tipo_pagto.key === '0') || (this.state.registro.contr_tipo_pagto.key === '') || (this.state.registro.contr_tipo_pagto.key === 'null')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento' });
      return;
    }

    const registro = {
      contr_idf: this.state.registro.contr_idf,
      contr_data_emissao: moment(this.state.registro.contr_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      contr_numero: this.state.registro.contr_numero ? this.state.registro.contr_numero : '0',
      contr_pessoa: this.state.registro.contr_pessoa.key,
      pes_nome: this.state.registro.contr_pessoa.label,
      contr_valor_inicial: this.state.registro.contr_valor_inicial,
      contr_valor_mensal: this.state.registro.contr_valor_mensal,
      contr_dia_venc: this.state.registro.contr_dia_venc,
      contr_controle: this.state.registro.contr_controle,
      contr_obs: this.state.registro.contr_obs,
      contr_vendedor: this.state.registro.contr_vendedor && this.state.registro.contr_vendedor.key ? this.state.registro.contr_vendedor.key : 0,
      contr_tipo_pagto: this.state.registro.contr_tipo_pagto && this.state.registro.contr_tipo_pagto.key ? String(this.state.registro.contr_tipo_pagto.key) : 0,
      contr_flag_fatura: this.state.registro.contr_flag_fatura,
      contr_flag_emite_nfe: this.state.registro.contr_flag_emite_nfe,
      contr_flag_emite_boleto: this.state.registro.contr_flag_emite_boleto,
    };

    this.props.onSalvarClick(registro);
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['contr_pessoa'] = event.contr_pessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['contr_vendedor'] = event.contr_vendedor;
    this.setState(event);
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['contr_tipo_pagto'] = event.contr_tipo_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onDateChange = event => {
    const { registro } = this.state;
    registro['contr_data_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ contr_data_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }


  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  // ----------------------------------------------------------------




  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoTela: 'pessoas'
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
      tipoTela: ''
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { modalListaVisible, tipoTela } = this.state;
    const { contr_idf, contr_numero, contr_data_emissao, contr_data_cancelamento, contr_pessoa, contr_vendedor,
      contr_valor_mensal, contr_valor_inicial, contr_dia_venc, contr_obs, contr_controle,
      contr_flag_fatura, contr_flag_emite_nfe, contr_flag_emite_boleto, contr_tipo_pagto } = this.state.registro;

    // console.log('ContratosForm.this.state: ', this.state);

    return (
      <Modal
        title={contr_idf ? (this.state.visualizando ? "Contrato" : "Edição de Contrato") : "Inclusão de Contrato"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >
        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={tipoTela}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <div style={{}}>
          <Form>
            <Row>

              <Col xs={24} sm={6} className="camposEspacoDireita">
                <span>Numero</span>
                <InputForm
                  id="contr_numero"
                  ref="contr_numero"
                  maxLength={9}
                  onChange={this.onChange}
                  value={contr_numero}
                  readOnly
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: 3 }} className="camposEspacoDireita">
                <span>Data Emissão</span>
                <DatePicker
                  onChange={this.onDateChange}
                  format="DD/MM/YYYY"
                  showToday={true}
                  allowClear={false}
                  value={moment(contr_data_emissao, "DD/MM/YYYY", true)}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={11}>
                <PessoaFrame
                  label="Cliente"
                  id="contr_pessoa"
                  value={contr_pessoa}
                  tipo="C"
                  width={"100%"}
                  onChange={this.onChangePessoa}
                  descricaoPrimeiroItem="Selecione um Cliente"
                />
              </Col>
              <Col xs={24} sm={1} style={{ marginTop: 24 }}>
                <Tooltip title="Cadastro de Clientes" placement="topLeft">
                  <Button
                    type="dashed"
                    icon="plus"
                    htmlType="button"
                    onClick={() => this.onCadPessoaClick()}
                  />
                </Tooltip>
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Valor Inicial</span>
                <InputForm
                  type="number"
                  id="contr_valor_inicial"
                  ref="contr_valor_inicial"
                  value={contr_valor_inicial}
                  onChange={this.onChange}
                />
              </Col>
              <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Valor Mensal</span>
                <InputForm
                  type="number"
                  id="contr_valor_mensal"
                  ref="contr_valor_mensal"
                  value={contr_valor_mensal}
                  onChange={this.onChange}
                />
              </Col>
              <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Dia Vencimento</span>
                <InputForm
                  type="number"
                  id="contr_dia_venc"
                  ref="contr_dia_venc"
                  value={contr_dia_venc}
                  decimalScale={0}
                  onChange={this.onChange}
                />
              </Col>
              <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                <span>Controle</span>
                <InputForm
                  id="contr_controle"
                  ref="contr_controle"
                  value={contr_controle}
                  maxLength={10}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                <UsuarioFrame
                  label="Vendedor"
                  id="contr_vendedor"
                  value={contr_vendedor}
                  width={"100%"}
                  vendedor={1}
                  onChange={this.onChangeVendedor}
                  descricaoPrimeiroItem="Selecione um Vendedor"
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <TipoDocFrame
                  label="Tipo Documento"
                  id="contr_tipo_pagto"
                  value={contr_tipo_pagto}
                  width={"100%"}
                  onChange={this.onChangeTipoDoc}
                  descricaoPrimeiroItem="Informe o Tipo de Documento"
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: -20 }} className="campoCheckBox">
                <InputForm
                  type="checkbox"
                  id="contr_flag_fatura"
                  ref="contr_flag_fatura"
                  onChange={this.onChange}
                  value={contr_flag_fatura ? true : false}
                >
                  Gera Faturamento
                </InputForm>
              </Col>
              <Col xs={24} sm={3} style={{ marginTop: -20 }} className="campoCheckBox">
                <InputForm
                  type="checkbox"
                  id="contr_flag_emite_nfe"
                  ref="contr_flag_emite_nfe"
                  onChange={this.onChange}
                  value={contr_flag_emite_nfe ? true : false}
                >
                  Emite NFe
                </InputForm>
              </Col>
              <Col xs={24} sm={3} style={{ marginTop: -20 }} className="campoCheckBox">
                <InputForm
                  type="checkbox"
                  id="contr_flag_emite_boleto"
                  ref="contr_flag_emite_boleto"
                  onChange={this.onChange}
                  value={contr_flag_emite_boleto ? true : false}
                >
                  Emite Boleto
                </InputForm>
              </Col>

              <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                <span>OBS</span>
                <InputForm
                  id="contr_obs"
                  ref="contr_obs"
                  value={contr_obs}
                  type="textarea"
                  rows={4}
                  maxLength={9500}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>
            </Row>

          </Form>
        </div>


        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ContratosForm.js